import { Link } from "react-router-dom";
import { ShieldCheck, Award, MessageSquare, HeartHandshake } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { Reveal, Overline } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

export const PageHero = ({ overline, title, subtitle }) => (
  <section className="bg-[#0B1B3D] relative grain pt-40 pb-20 md:pb-28">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal>
        <Overline light>{overline}</Overline>
        <h1 className="font-heading font-extrabold text-white tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.02]">{title}</h1>
        {subtitle && <p className="text-slate-400 text-base md:text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

const VALUE_ICONS = [ShieldCheck, Award, MessageSquare, HeartHandshake];

export default function AboutPage() {
  const { settings, L } = useSite();
  return (
    <main data-testid="about-page">
      <Seo title={PAGE_SEO.about.title} description={PAGE_SEO.about.description} path="/about" />
      <PageHero overline={L.about.overline} title={L.about.title}
        subtitle={settings.about_text} />
      <section className="py-24 md:py-32 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {L.about.values.map((v, i) => {
              const Icon = VALUE_ICONS[i];
              return (
                <Reveal key={v.t} delay={i * 0.06}>
                  <div className="bg-white border border-slate-200 p-10 h-full">
                    <Icon className="w-8 h-8 text-[#005AE0] mb-6" />
                    <h3 className="font-heading font-bold text-[#0B1B3D] text-xl mb-3">{v.t}</h3>
                    <p className="text-slate-500 leading-relaxed">{v.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <Reveal className="mt-16 text-center">
            <Link to="/estimate" data-testid="about-estimate-btn" className="btn-primary">{L.header.requestFreeEstimate}</Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
